<template>
 <v-app>

    <v-toolbar app clipped-left dark color="primary">
      <img src="static/img/logo.png" style="height: 48px; margin: 4px 0px;" alt="Logo do Arbopasto" class="hidden-lg-and-up" />
      <img src="static/img/logo.png" style="height: 56px;" alt="Logo do Arbopasto" class="hidden-md-and-down" />
      <v-toolbar-title>Arbopasto</v-toolbar-title>
      <v-spacer class="hidden-sm-and-down"></v-spacer>

      <v-text-field v-if="filter" append-icon="search" label="Buscar..." single-line hide-details v-model="search.text" class="mx-2 mr-3 hidden-sm-and-down" color="white" />
      <div class="d-flex align-center" style="margin-left: auto">

      <v-btn icon class="hidden-md-and-up" @click="sync()" :disabled="loading">
        <v-icon>sync</v-icon>
      </v-btn>

      <v-btn outline color="white" class="mr-3 ml-0 hidden-sm-and-down" @click="sync()" :disabled="loading">
        <v-icon left>sync</v-icon>
        Sincronizar
      </v-btn>

      <v-btn icon class="hidden-md-and-up" @click="dialogsCreate.create = !dialogsCreate.create">
        <v-icon>tune</v-icon>
      </v-btn>

      <v-btn outline color="white" class="mr-3 ml-0 hidden-sm-and-down" @click="dialogsCreate.create = !dialogsCreate.create">
        <v-icon left>tune</v-icon>
        Filtros
      </v-btn>

      <v-btn icon class="hidden-md-and-up" @click="about()">
        <v-icon>info</v-icon>
      </v-btn>

      <v-btn outline color="white" class="ml-0 hidden-sm-and-down" @click="about()">
        <v-icon left>info</v-icon>
        Sobre
      </v-btn>

      </div>

      <beta v-if="!$vuetify.breakpoint.smAndDown"></beta>
     
    </v-toolbar>
    
  <v-container fluid>
      <v-flex xs12 v-if="searchResults">
        <v-card color="green darken-2" class="white--text">
          <v-card-title primary-title>
            <div>
              <span class="headline">Árvore não encontrada!</span><br>
              <span>Não encontramos uma árvore corresponde para sua pesquisa. Verifique o nome da árvore e tente novamente.</span>
            </div>
          </v-card-title>
        </v-card>
      </v-flex>
    
    <v-layout row wrap>
      <v-flex xs12 class="hidden-md-and-up px-1 my-0 py-0">
        <v-text-field append-icon="search" label="Buscar..." single-line hide-details v-model="search.text" />
      </v-flex>

      <v-flex xs12 class="hidden-md-and-up px-1 my-0 pt-0 py-1">
        <v-btn v-if="isCleanFilter" block outline color="indigo" @click="clearFilter()">
          <v-icon left>delete</v-icon>
          Limpar Filtros
        </v-btn>
      </v-flex>

      <v-flex xs12 sm6 md4 lg4 xl3 class="px-1 py-2" v-for="(tree, i) in filter" :key="i">
        <v-card>
          <v-img
            v-if="typeof tree.pictures[0] === 'object'" 
            :aspect-ratio="1" 
            :alt="tree.pictures[0].description_of_image" 
            :src="tree.pictures[0].base64"
            class="grey lighten-2">
            <v-layout slot="placeholder" fill-height align-center justify-center ma-0>
              <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
            </v-layout>
          </v-img>
          <v-layout row>
            <v-flex xs9>
              <v-card-title primary-title style="min-height: 100px;">
                <div>
                  <div class="headline">{{tree.common_name}}</div>
                  <div style="font-style: italic;">{{ tree.family }}</div>
                </div>
              </v-card-title>
            </v-flex>
            <v-flex xs3>
              <v-card-actions style="height: 100px;">
                <v-spacer></v-spacer>
                <v-btn flat icon large color="success" @click="info(tree)">
                    <v-icon large>info</v-icon>
                </v-btn>
              </v-card-actions>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>

      <v-flex xs12>
        <p class="text-xs-center my-4">
          <img src="/static/img/embrapa.png" style="width: 150px;" alt="Logo da Embrapa" />
        </p>
      </v-flex>

    </v-layout>

    <confirm-wrapper ref="confirm" />
    <message-wrapper ref="message" />

    <v-dialog v-model="wait" persistent width="300" hide-overlay no-click-animation>
      <v-card color="teal" dark>
        <v-card-text>
          Por favor, aguarde...
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
        
      <v-dialog v-model="dialogsCreate.create" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card>
          <v-toolbar dark color="primary">
            <v-btn icon dark @click.native="dialogsCreate.create = false">
              <v-icon>arrow_back</v-icon>
            </v-btn>
            <v-toolbar-title class="mx-0 px-0">Filtros</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn icon class="hidden-md-and-up" @click="clearFilter()">
                <v-icon>clear</v-icon>
              </v-btn>

              <v-btn flat color="white" class="hidden-sm-and-down" @click="clearFilter()">
                Limpar
              </v-btn>

              <v-btn icon class="hidden-md-and-up" @click="filterClick()">
                <v-icon>done</v-icon>
              </v-btn>

              <v-btn flat color="white" class="hidden-sm-and-down" @click="filterClick()">
                Aplicar
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-container>
            <v-form ref="form" lazy-validation>
              <v-layout row wrap>

                <v-flex xs12 sm6 class="px-1">
                  <v-text-field v-model="search.text" label="Nome da árvore..."></v-text-field>
                </v-flex>

                <v-flex xs12 sm6 class="px-1">
                  <v-select v-model="itemsFilter.producao_de_mudas.value" :items="itemsFilter.producao_de_mudas.items" attach chips label="Produção de Mudas" multiple ></v-select>
                </v-flex>

                <v-flex xs12 sm6 class="px-1">
                <v-select v-model="itemsFilter.valor_comercial_da_madeira.value" :items="itemsFilter.valor_comercial_da_madeira.items" attach chips label="Valor comercial da madeira" multiple></v-select>
                </v-flex>

                <v-flex xs12 sm6 class="px-1">
                <v-select v-model="itemsFilter.produtos_nao_madeireiros_com_valor_comercial.value" :items="itemsFilter.produtos_nao_madeireiros_com_valor_comercial.items" attach chips label="Produtos não madeireiros com valor comercial" clearable></v-select>
                </v-flex>

                <v-flex xs12 sm6 class="px-1">
                <v-select v-model="itemsFilter.fixacao_biologica_de_nitrogenio.value" :items="itemsFilter.fixacao_biologica_de_nitrogenio.items" attach chips label="Fixação biológica de nitrogênio" clearable></v-select>
                </v-flex>

                <v-flex xs12 sm6 class="px-1">
                <v-select v-model="itemsFilter.velocidade_de_crescimento.value" :items="itemsFilter.velocidade_de_crescimento.items" attach chips label="Velocidade de crescimento" multiple></v-select>
                </v-flex>

                <v-flex xs12 sm6 class="px-1">
                <v-select v-model="itemsFilter.potencial_forrageiro_dos_frutos.value" :items="itemsFilter.potencial_forrageiro_dos_frutos.items" attach chips label="Potencial forrageiro dos frutos" clearable></v-select>
                </v-flex>

                <v-flex xs12 sm6 class="px-1">
                <v-select v-model="itemsFilter.potencial_toxico_dos_frutos.value" :items="itemsFilter.potencial_toxico_dos_frutos.items" attach chips label="Potencial tóxico dos frutos" multiple></v-select>
                </v-flex>

                <v-flex xs12 sm6 class="px-1">
                <v-select v-model="itemsFilter.tolerancia_ao_fogo_em_pastagens.value" :items="itemsFilter.tolerancia_ao_fogo_em_pastagens.items" attach chips label="Tolerância ao fogo em pastagens" multiple></v-select>
                </v-flex>

                <v-flex xs12 sm6 class="px-1">
                <v-select v-model="itemsFilter.presenca_de_raizes_superficiais_sob_a_copa.value" :items="itemsFilter.presenca_de_raizes_superficiais_sob_a_copa.items" attach chips label="Presença de raízes superficiais sob a copa" multiple></v-select>
                </v-flex>

                <v-flex xs12 sm6 class="px-1">
                <v-select v-model="itemsFilter.interferencia_no_pasto_sob_a_copa.value" :items="itemsFilter.interferencia_no_pasto_sob_a_copa.items" attach chips label="Interferência no pasto sob a copa" multiple></v-select>
                </v-flex>

                <v-flex xs12 sm6 class="px-1">
                <v-select v-model="itemsFilter.regeneracao_natural_em_pastagens.value" :items="itemsFilter.regeneracao_natural_em_pastagens.items" attach chips label="Regeneração natural em pastagens" multiple></v-select>
                </v-flex>

                <v-flex xs12 sm6 class="px-1">
                <v-select v-model="itemsFilter.qualidade_do_fuste.value" :items="itemsFilter.qualidade_do_fuste.items" attach chips label="Qualidade do fuste" multiple></v-select>
                </v-flex>

                <v-flex xs12 sm6 class="px-1">
                <v-select v-model="itemsFilter.forma_da_copa_em_pastagens.value" :items="itemsFilter.forma_da_copa_em_pastagens.items" attach chips label="Forma da copa em pastagens" multiple></v-select>
                </v-flex>

                <v-flex xs12 sm6 class="px-1">
                <v-select v-model="itemsFilter.densidade_da_copa.value" :items="itemsFilter.densidade_da_copa.items" attach chips label="Densidade da copa" multiple></v-select>
                </v-flex>

                <v-flex xs12 sm6 class="px-1">
                <v-select v-model="itemsFilter.porte_das_arvores_em_pastagens.value" :items="itemsFilter.porte_das_arvores_em_pastagens.items" attach chips label="Porte das árvores em pastagens" multiple></v-select>
                </v-flex>

              </v-layout>
            </v-form>
          </v-container>
        </v-card>
      </v-dialog>
  </v-container>

  <v-snackbar v-model="loading" bottom multi-line :timeout="loadingTimeout">
    Salvando o catálogo...
    <v-progress-circular :value="loadingProgress" color="white">
      {{ loadingCounter }}
    </v-progress-circular>
  </v-snackbar>

  <about-wrapper ref="about"></about-wrapper>
  <info-wrapper ref="info"></info-wrapper>
  <settings-wrapper ref="settings"></settings-wrapper>

 </v-app>
</template>


<script>
import manifest from '../../static/manifest.json'

import SettingsWrapper from '../components/Settings'
import InfoWrapper from '../components/Info'
import ConfirmWrapper from '../components/Confirm'
import MessageWrapper from '../components/Message'
import AboutWrapper from '../components/About'
import Beta from '../components/Beta'

import timestamp from 'unix-timestamp'
import axios from 'axios'
import image2base64 from 'image-to-base64'
import _ from 'lodash'

var settings = require('../settings/' + process.env.NODE_ENV)

const BASE_URL = settings.url
const BASE_URL_API_REST = BASE_URL + settings.api
const BASE_URL_API_STATUS = BASE_URL + settings.status
const BASE_URL_API_IMAGE_CROP = BASE_URL + settings.image_crop
// const BASE_URL_API_IMAGE_BASE64 = BASE_URL + settings.image_base64

export default {
  components: {
    AboutWrapper,
    ConfirmWrapper,
    MessageWrapper,
    InfoWrapper,
    SettingsWrapper,
    Beta
  },
  data () {
    return {
      appName: 'Arbopasto',
      picture: null,
      manifest: manifest,
      sidebar: false,
      wait: false,
      sizeResults: 0,
      isCleanFilter: null,
      countClick: 0,
      show: false,
      category: null,
      dialog: false,
      notifications: false,
      itemsFilter: {
        producao_de_mudas: {
          items: ['Fácil', 'Regular', 'Difícil'],
          value: []
        },
        valor_comercial_da_madeira: {
          items: ['Nenhum', 'Baixo', 'Moderado', 'Alto'],
          value: []
        },
        produtos_nao_madeireiros_com_valor_comercial: {
          items: ['Nenhum', 'Pelo menos um'],
          value: null
        },
        fixacao_biologica_de_nitrogenio: {
          items: ['Sim', 'Não'],
          value: null
        },
        velocidade_de_crescimento: {
          items: ['Lento', 'Moderado', 'Rápido', 'Muito Rápido'],
          value: []
        },
        potencial_forrageiro_dos_frutos: {
          items: ['Sim', 'Não'],
          value: null
        },
        potencial_toxico_dos_frutos: {
          items: ['Sim', 'Não', 'Há indícios'],
          value: []
        },
        tolerancia_ao_fogo_em_pastagens: {
          items: ['Baixa', 'Média', 'Alta'],
          value: []
        },
        presenca_de_raizes_superficiais_sob_a_copa: {
          items: ['Baixa', 'Moderada', 'Alta', 'Muito Alta', 'Muito Baixa'],
          value: []
        },
        interferencia_no_pasto_sob_a_copa: {
          items: ['Baixa', 'Moderada', 'Muito Baixa'],
          value: []
        },
        regeneracao_natural_em_pastagens: {
          items: ['Adequada', 'Baixa', 'Média', 'Alta', 'Excessiva'],
          value: []
        },
        qualidade_do_fuste: {
          items: ['Péssimo', 'Ruim', 'Regular', 'Bom', 'Ótima'],
          value: []
        },
        forma_da_copa_em_pastagens: {
          items: ['Caliciforme', 'Colunar', 'Cônica', 'Elíptica horizontal', 'Elíptica vertical', 'Flabeliforme', 'Globosa', 'Palmeira', 'Umbeliforme'],
          value: []
        },
        densidade_da_copa: {
          items: ['Rala', 'Pouco densa', 'Densa', 'Muito Densa'],
          value: []
        },
        porte_das_arvores_em_pastagens: {
          items: ['Baixo', 'Médio', 'Alto'],
          value: []
        }
      },
      sound: true,
      dialogsCreate: {
        create: false,
        delete: false
      },
      widgets: false,
      windowWidth: 0,
      windowHeight: 0,
      name: '',
      records: [],
      trees: [],
      checkResults: null,
      searchResults: null,
      dialogs: {
        create: false,
        delete: false
      },
      search: {
        display: false,
        text: '',
        filter: false,
        checkbox: []
      },
      rules: {
        name: [
          v => (v && v.trim().length > 0) || 'Insira um nome para este item!',
          v => (v && v.length <= 15) || 'O nome não pode ter mais de 15 caracteres!'
        ],
        farm: [
          v => (v && v.trim().length > 0) || 'Insira o nome da propriedade!',
          v => (v && v.length <= 50) || 'A propriedade não pode ter mais de 50 caracteres!'
        ],
        number: [ // Essa validação aceita o ZERO
          v => ((v && !isNaN(v)) || (v === 0)) || 'Insira um número inteiro!'
        ],
        percent: [
          v => (v && !isNaN(v) && v > 0 && v <= 100) || 'Insira uma porcentagem (0-100%)!'
        ]
      },
      loading: false,
      loadingTotal: 0,
      loadingCounter: 0,
      loadingProgress: 0,
      loadingTimeout: 0
    }
  },
  computed: {
    filter () {
      console.log('filter')
      this.records = this.trees
      var array = []
      var quant = 0

      if (this.category !== null) {
        console.log('category: ' + this.category)
        // filtra os dados por bioma
        this.records.forEach(app => {
          if (app.biome.indexOf(this.category) !== -1) {
            array.push(app)
          }
        })
        // carrega o novo array filtrado
        this.records = array
        quant = array.length
        // verifica o se é vazio
        if (quant === 0) {
          this.checkResults = true
          console.log('array empty')
        } else {
          this.checkResults = null
          console.log('array have data, size: ' + array.length)
        }
      }
      // Order Lodash
      var dataOrdened = _.orderBy(this.records, 'common_name')
      var pre = dataOrdened.length
      console.log('pre: ' + pre)
      var dataFilter = dataOrdened.filter(item => {
        return (
          item.common_name.toLowerCase().indexOf(this.search.text.toLowerCase()) > -1 ||
          item.other_common_names.toLowerCase().indexOf(this.search.text.toLowerCase()) > -1 ||
          item.scientific_name.toLowerCase().indexOf(this.search.text.toLowerCase()) > -1
        )
      })

      var self = this

      dataFilter = _.filter(dataFilter, tree => {
        var filters = self.itemsFilter.producao_de_mudas.value

        if (filters.length === 0) {
          return true
        }
        for (var i = 0; i < filters.length; i++) {
          if (filters[i] === tree.producao_de_mudas) {
            return true
          }
        }
        return false
      })

      dataFilter = _.filter(dataFilter, tree => {
        var filters = self.itemsFilter.valor_comercial_da_madeira.value

        if (filters.length === 0) {
          return true
        }
        for (var i = 0; i < filters.length; i++) {
          if (filters[i] === tree.valor_comercial_da_madeira) {
            return true
          }
        }
        return false
      })

      dataFilter = _.filter(dataFilter, tree => {
        var filters = self.itemsFilter.produtos_nao_madeireiros_com_valor_comercial.value

        if (filters === null || filters === undefined || filters === tree.produtos_nao_madeireiros_com_valor_comercial) {
          return true
        }

        return false
      })

      dataFilter = _.filter(dataFilter, tree => {
        var filters = self.itemsFilter.fixacao_biologica_de_nitrogenio.value

        if (filters === null || filters === undefined || filters === tree.fixacao_biologica_de_nitrogenio) {
          return true
        }
        return false
      })

      dataFilter = _.filter(dataFilter, tree => {
        var filters = self.itemsFilter.velocidade_de_crescimento.value

        if (filters.length === 0) {
          return true
        }
        for (var i = 0; i < filters.length; i++) {
          if (filters[i] === tree.velocidade_de_crescimento) {
            return true
          }
        }
        return false
      })

      dataFilter = _.filter(dataFilter, tree => {
        var filters = self.itemsFilter.potencial_forrageiro_dos_frutos.value

        if (filters === null || filters === undefined || filters === tree.potencial_forrageiro_dos_frutos) {
          return true
        }

        return false
      })

      dataFilter = _.filter(dataFilter, tree => {
        var filters = self.itemsFilter.potencial_toxico_dos_frutos.value

        if (filters.length === 0) {
          return true
        }
        for (var i = 0; i < filters.length; i++) {
          if (filters[i] === tree.potencial_toxico_dos_frutos) {
            return true
          }
        }
        return false
      })

      dataFilter = _.filter(dataFilter, tree => {
        var filters = self.itemsFilter.tolerancia_ao_fogo_em_pastagens.value

        if (filters.length === 0) {
          return true
        }
        for (var i = 0; i < filters.length; i++) {
          if (filters[i] === tree.tolerancia_ao_fogo_em_pastagens) {
            return true
          }
        }
        return false
      })

      dataFilter = _.filter(dataFilter, tree => {
        var filters = self.itemsFilter.presenca_de_raizes_superficiais_sob_a_copa.value

        if (filters.length === 0) {
          return true
        }
        for (var i = 0; i < filters.length; i++) {
          if (filters[i] === tree.presenca_de_raizes_superficiais_sob_a_copa) {
            return true
          }
        }
        return false
      })

      dataFilter = _.filter(dataFilter, tree => {
        var filters = self.itemsFilter.interferencia_no_pasto_sob_a_copa.value

        if (filters.length === 0) {
          return true
        }
        for (var i = 0; i < filters.length; i++) {
          if (filters[i] === tree.interferencia_no_pasto_sob_a_copa) {
            return true
          }
        }
        return false
      })

      dataFilter = _.filter(dataFilter, tree => {
        var filters = self.itemsFilter.regeneracao_natural_em_pastagens.value

        if (filters.length === 0) {
          return true
        }
        for (var i = 0; i < filters.length; i++) {
          if (filters[i] === tree.regeneracao_natural_em_pastagens) {
            return true
          }
        }
        return false
      })

      dataFilter = _.filter(dataFilter, tree => {
        var filters = self.itemsFilter.qualidade_do_fuste.value

        if (filters.length === 0) {
          return true
        }
        for (var i = 0; i < filters.length; i++) {
          if (filters[i] === tree.qualidade_do_fuste) {
            return true
          }
        }
        return false
      })

      dataFilter = _.filter(dataFilter, tree => {
        var filters = self.itemsFilter.forma_da_copa_em_pastagens.value

        if (filters.length === 0) {
          return true
        }
        for (var i = 0; i < filters.length; i++) {
          if (filters[i] === tree.forma_da_copa_em_pastagens) {
            return true
          }
        }
        return false
      })

      dataFilter = _.filter(dataFilter, tree => {
        var filters = self.itemsFilter.densidade_da_copa.value

        if (filters.length === 0) {
          return true
        }
        for (var i = 0; i < filters.length; i++) {
          if (filters[i] === tree.densidade_da_copa) {
            return true
          }
        }
        return false
      })

      dataFilter = _.filter(dataFilter, tree => {
        var filters = self.itemsFilter.porte_das_arvores_em_pastagens.value

        if (filters.length === 0) {
          return true
        }
        for (var i = 0; i < filters.length; i++) {
          if (filters[i] === tree.porte_das_arvores_em_pastagens) {
            return true
          }
        }
        return false
      })

      this.sizeResults = dataFilter.length

      return dataFilter
    }
  },
  update () {
    console.log('update')
  },
  mounted () {
    this.countClick = 0

    if (!this.$root.$data.trySync) {
      this.refresh()
    } else {
      this.sync()
    }
  },
  methods: {
    menu (category) {
      this.category = category
      this.syncApp = category

      if (this.$vuetify.breakpoint.smAndDown) {
        this.sidebar = false
      }
    },
    settings () {
      console.log('settings')
      this.$refs.settings.show(2)
    },
    about () {
      this.$refs.about.show()
    },
    refresh () {
      this.searchResults = null

      var self = this

      self.$db.tree
        .reverse().sortBy('common_name')
        .then(trees => {
          self.records = trees
          self.trees = trees

          self.wait = false
        })
    },
    appendIconCallback () {
      console.log('click-close-search')
      this.countClick++
      if (this.countClick > 1) {
        console.log('count > 1: ')
        this.search.display = false
        this.search.text = ''
      } else {
        console.log('count: ' + this.countClick)
        this.search.text = ''
      }
    },
    prependIconCallback () {
      console.log('end')
    },
    cancelDialog () {
      this.dialogsCreate.create = false
      this.search.text = ''
    },
    filterClick () {
      if (this.search.filter === true) {
        this.search.filter = false
      } else {
        this.search.filter = true
      }
      // Fazer a busca
      this.dialogsCreate.create = false
      this.isCleanFilter = true
    },
    clearFilter () {
      this.dialogsCreate.create = false
      this.isCleanFilter = null
      this.search.text = ''
      this.itemsFilter.producao_de_mudas.value = []
      this.itemsFilter.valor_comercial_da_madeira.value = []
      this.itemsFilter.produtos_nao_madeireiros_com_valor_comercial.value = null
      this.itemsFilter.fixacao_biologica_de_nitrogenio.value = null
      this.itemsFilter.velocidade_de_crescimento.value = []
      this.itemsFilter.potencial_forrageiro_dos_frutos.value = null
      this.itemsFilter.potencial_toxico_dos_frutos.value = []
      this.itemsFilter.tolerancia_ao_fogo_em_pastagens.value = []
      this.itemsFilter.presenca_de_raizes_superficiais_sob_a_copa.value = []
      this.itemsFilter.interferencia_no_pasto_sob_a_copa.value = []
      this.itemsFilter.regeneracao_natural_em_pastagens.value = []
      this.itemsFilter.qualidade_do_fuste.value = []
      this.itemsFilter.forma_da_copa_em_pastagens.value = []
      this.itemsFilter.densidade_da_copa.value = []
      this.itemsFilter.porte_das_arvores_em_pastagens.value = []
    },
    searchClick () {
      if (this.search.display === true) {
        this.search.display = false
      } else {
        this.search.display = true
        this.search.text = ''
      }
    },
    info (tree) {
      console.log('info')
      this.$refs.info.show(tree)
    },
    async insertTree (tree) {
      // console.log('insert-tree: ' + JSON.stringify(tree))
      console.log('insert')
      var self = this

      self.$db.transaction('rw', self.$db.tree, async () => {
        console.log('transaction')
        await self.$db.tree.put(tree)
      }).then(res => {
        console.log('then')
      }).catch(error => {
        console.log('catch: ' + error)
      }).finally(() => {
        // console.log('finaly')
      })
    },
    tryCache () {
      var self = this

      this.$db.tree
        .where('cached').equals(0)
        .sortBy('getted')
        .then(trees => {
          if (trees.length > 0) {
            console.log('Has images to cache: ' + trees.length + ' trees!')

            self.loading = true
            self.loadingTotal = self.loadingCounter = trees.length

            trees.forEach(tree => {
              self.imageCaching(tree)
            })
          }
        })
    },
    async imageCaching (tree) {
      var self = this

      let promises = []

      var flag = 0

      tree.pictures.forEach(pic => {
        if (flag++ > 0) {
          console.log('Caching picture: ' + BASE_URL_API_IMAGE_CROP + pic.image_path)

          promises.push(image2base64(pic.image_path).then(response => {
            pic.base64 = 'data:image/jpeg;base64,' + response
          }))
        }
      })

      Promise.all(promises).then(results => {
        tree.cached = 1

        self.$db.tree.put(tree).then(res => {
          console.log('Saving in DB: ' + tree.common_name)

          var step = 100 / self.loadingTotal
          var sum = self.loadingProgress + step

          self.loadingProgress = sum >= 100 ? 100 : sum

          if (--self.loadingCounter === 0) {
            self.loading = false
          }
        }).catch(error => {
          console.log(error)
        })
      })
    },
    sync () {
      this.wait = true
      var self = this

      var err = function (error) {
        console.log(error)

        self.wait = false

        self.$refs.message.open('Atenção! Erro ao tentar sincronizar. Por favor, tente novamente mais tarde.', 'error')

        self.$err(error)
      }

      console.log('#1 - Trying to connect in remote server.')

      var now = timestamp.now()
      var ts = this.$localStorage.get('synchronized')

      var lastSync = timestamp.toDate(ts)

      console.log('Now: ' + now)

      console.log('Verify server status: GET ' + BASE_URL_API_STATUS)

      axios.get(BASE_URL_API_STATUS, { timeout: 5000 }).then(function (response) {
        console.log('#2 - Getting from local DB all items edited from last sync: ' + lastSync)

        console.log('GET ' + BASE_URL_API_REST + '&LAST_SYNC=' + self.$localStorage.get('synchronized'))

        axios.get(BASE_URL_API_REST + '&LAST_SYNC=' + self.$localStorage.get('synchronized')).then(response => {
          var sizeResponse = response.data.trees.length

          if (sizeResponse === 0) {
            console.log('Results new trees: ' + sizeResponse)
          }

          var items = []

          if (response.data.message === 'SUCCESS') {
            items = response.data.trees
          }

          var promises = []

          items.forEach(tree => {
            tree.cached = 0
            tree.getted = timestamp.now()

            tree.pictures.forEach(picture => {
              picture.image_path = BASE_URL_API_IMAGE_CROP + picture.image_path
            })

            if (tree.pictures.length > 0) {
              promises.push(image2base64(tree.pictures[0].image_path).then(response => {
                tree.pictures[0].base64 = 'data:image/jpeg;base64,' + response
              }))
            }
          })

          Promise.all(promises).then(results => {
            console.log('#3 - Saving all items getted from server and deleting inactivated items.')

            items.forEach(tree => {
              self.$db.tree.put(tree)
            })

            console.log('#4 - Updating control variables!')

            var now = timestamp.now()
            self.$localStorage.set('synchronized', now)
            self.$root.$data.trySync = false

            console.log('#5 - Refreshing list of trees!')

            self.refresh()

            console.log('#6 - All done!')

            setTimeout(function () {
              self.tryCache()
            }, 1000)
          }).catch(error => {
            err(error)
          })
        }).catch(error => {
          err(error)
        })
      }).catch(error => {
        console.log(error)

        self.$err(error)

        self.$root.$data.trySync = false

        self.refresh()

        self.$refs.message.open('Atenção! O servidor remoto parece estar indisponível para sincronização dos dados. Por favor, verifique sua conexão com a internet ou tente novamente mais tarde.', 'yellow darken-3', 3000)
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
div.v-card__media__background {
  margin: 15px 0px;
  height: 170px;
}
div.v-card__title,
div.v-card__actions {
  background-color: rgba(255,255,255,0.1);
}
#input-usage .v-input__prepend-outer,
#input-usage .v-input__append-outer,
#input-usage .v-input__slot,
#input-usage .v-messages {
  border: 1px dashed rgba(0,0,0, .4);
}
img {
  max-width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/Trees.vue